import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import EvalComparisonRow from "./EvalComparisonRow"
// levenshtein distance
// import { wordErrorRate } from "word-error-rate";

// EvalChunkComparison
const EvalChunkComparison = (props) => {

  let [wer, setWer] = useState('')
  let [humanScore, setHumanScore] = useState(0)
  let [pairList, setPairList] = useState([]);
  let [listOfList, setListOfList] = useState([]);

  // init pairlist
  useEffect(() => {

    // console.log("EvalChunkComparison:")

    let _pairList = []

    if (props.pairList) {

      // console.log("setPairList.1")
      setPairList(props.pairList)

    } else {

      // create pair list
      let _arr1 = []
      for (let i=0; i<props.evalSeikaiArr.length; i++) {
        let _seikai = props.evalSeikaiArr[i]
        let _prediction = props.evalPredictionArr[i]

        let _status = 'ng'
        if (_seikai === _prediction) {
          _status = 'ok'
        }

        if (_seikai === "_") {
          _seikai = "　"
        }
        if (_prediction === "_") {
          _prediction = "　"
        }

        _arr1.push({
          // globalidx: i,
          globalidx: _arr1.length,
          seikai: _seikai,
          prediction: _prediction,
          status: _status,
        })
      }

      // console.log("_arr1: ", _arr1)
      // console.log("setPairList.2")
      setPairList(_arr1)

      _pairList = _arr1
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.evalSeikaiArr, props.evalPredictionArr]);

  // create list of list
  let _recalcurateLisOfList = (pairList) => {

    // console.log("_recalcurateLisOfList: ", pairList)

    if (!pairList) {
      return;
    }
    if (pairList.length === 0) {
      return;
    }

    let _arr21 = []
    let _arr22 = []

    for ( let i=0; i<pairList.length; i++ ) {

      let _item2 = pairList[i]

      _arr21.push(_item2)

      if (i % 12 === 11) {

        _arr22.push(_arr21)
        _arr21 = []

      }
    }
    _arr22.push(_arr21)
    _arr21 = []
    setListOfList(_arr22)

    // calcurate wer
    _calcurateWer()

    if (props.humanScore) {
      setHumanScore(props.humanScore)
    }
  }

  // componentDidMount
  useEffect(() => {

    // console.log("_recalcurateLisOfList 1: ", pairList)

    if (pairList.length === 0) {
      return
    }
    _recalcurateLisOfList(pairList)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairList]);




  //  updatePairList
  let _updatePairListPred = ({
    globalidx,
    prediction,
    status,
  }) => {

    if (globalidx !== 0 && !globalidx) {
      return;
    }

    let _pairList = pairList

    if (prediction) {
      _pairList[globalidx].prediction = prediction
    }

    // if status is given, then use that status
    if (status) {

      _pairList[globalidx].status = status

    } else {

      if ( _pairList[globalidx].prediction === _pairList[globalidx].seikai ) {
        if ( _pairList[globalidx].prediction === "　") {
          // do nothing...
        } else {
          _pairList[globalidx].status = 'ok'
        }
      } else {
        _pairList[globalidx].status = 'ng'
      }
    }


    // set pair list
    // console.log("setPairList.3")
    setPairList(_pairList)

    // useEffect is not working for list of objects
    // console.log("_recalcurateLisOfList 2")
    _recalcurateLisOfList(_pairList)

    // set blank index -1
    props.setBlankIndex(-1)
  }





  //  updatePairListSeikai shold be combine with updatePairList?
  let _updatePairListSeikai = ({
    globalidx,
    seikai,
    status,
  }) => {

    if (globalidx !== 0 && !globalidx) {
      return;
    }

    let _pairList = pairList

    if (seikai) {
      _pairList[globalidx].seikai = seikai
    }

    // if status is given, then use that status
    if (status) {
      _pairList[globalidx].status = status
    } else {
      if ( _pairList[globalidx].prediction === _pairList[globalidx].seikai ) {
        if ( _pairList[globalidx].prediction === "　") {
          // do nothing...
        } else {
          _pairList[globalidx].status = 'ok'
        }
      } else {
        _pairList[globalidx].status = 'ng'
      }
    }


    // set pair list
    // console.log("setPairList.4")
    setPairList(_pairList)

    // useEffect is not working for list of objects
    // console.log("_recalcurateLisOfList 3")
    _recalcurateLisOfList(_pairList)

    // set blank index -1
    props.setBlankIndex(-1)
  }







  //  _updateWordType
  let _updateWordType = ({
    globalidx,
    wordType,
  }) => {

    if (globalidx !== 0 && !globalidx) {
      return;
    }

    let _pairList = pairList
    _pairList[globalidx].wordType = wordType
  }







  // _calcurateWer
  let _calcurateWer = () => {

    // process texts
    let _results = _processTexts()
    let _seikaiTexts = _results.seikaiTexts
    let _predictionTexts = _results.predictionTexts

    // wordErrorRate
    // let _wer = wordErrorRate(_predictionTexts, _seikaiTexts)
    let _wer = 0.0
    setWer(_wer)

    props.reportWer(_wer)

  }

  // prodcess seikai and predicted texts
  let _processTexts = () => {

    // re compose seikai texts
    let _seikaiTexts = ""
    for (let i=0; i<pairList.length; i++) {

      // if (pairList[i].status === "ok" && pairList[i].seikai !== pairList[i].prediction) {
      //   continue
      // }
      if (pairList[i].status === "skip" && pairList[i].seikai !== pairList[i].prediction) {
        continue
      }
      if (pairList[i].seikai === "_" || pairList[i].seikai === "　") {
        continue
      }

      _seikaiTexts = _seikaiTexts + " " + pairList[i].seikai
    }
    _seikaiTexts = _seikaiTexts.trim()

    // re compose prediction texts
    let _predictionTexts = ""
    for (let i=0; i<pairList.length; i++) {

      if (pairList[i].status === "skip" && pairList[i].seikai !== pairList[i].prediction) {
        continue
      }
      if (pairList[i].status === "ok" && pairList[i].seikai !== pairList[i].prediction) {
        _predictionTexts = _predictionTexts + " " + pairList[i].seikai
        continue
      }
      if (pairList[i].prediction === "_" || pairList[i].prediction === "　") {
        continue
      }

      _predictionTexts = _predictionTexts + " " + pairList[i].prediction
    }
    _predictionTexts = _predictionTexts.trim()

    // console.log("_predictionTexts: ", "|"+_predictionTexts+"|")

    return {
      seikaiTexts: _seikaiTexts,
      predictionTexts: _predictionTexts,
    }
  }

  // save results
  let _saveResults = () => {

    // process texts
    let _results = _processTexts()
    let _seikaiTexts = _results.seikaiTexts
    let _predictionTexts = _results.predictionTexts

    // wordErrorRate
    // let _wer = wordErrorRate(_seikaiTexts, _predictionTexts)
    let _wer = 0.0

    // save _seikaiTexts, _predictionTexts, wer, humanScore
    props.savePredictionAndWer({
      wer: _wer,
      humanScore: humanScore,
      pairList: pairList,
    })
  }

  // _thumbsDown
  let _thumbsDown = () => {

    let _humanScore = humanScore
    _humanScore = _humanScore - 1
    if (_humanScore < -2) {
      _humanScore = -2
    }
    setHumanScore(_humanScore)

  }

  // _thumbsUp
  let _thumbsUp = () => {
    let _humanScore = humanScore
    _humanScore = _humanScore + 1
    if (_humanScore > 2) {
      _humanScore = 2
    }
    setHumanScore(_humanScore)
  }

  return (
    <div>

      {listOfList && listOfList.map((list1, idx1) => (

        <EvalComparisonRow
          accountType={props.accountType}
          updatePairList={_updatePairListPred}
          updatePairListSeikai={_updatePairListSeikai}
          updateWordType={_updateWordType}
          key={list1.toString()+idx1}
          idx={idx1}
          pairListRow={list1} />
      ))}

    </div>
  )
}

export default EvalChunkComparison
